import type { FecJournalMappingWithImport } from '../types/fecJournalMappingWithImport'

const getSiblingIds = (mapping: FecJournalMappingWithImport): string[] => mapping.siblingIds ?? []

export const getFecJournalIdentityKey = (mapping: FecJournalMappingWithImport): string =>
  `${mapping.journalCode}\0${mapping.journalLib}`

export const dedupeFecJournalMappings = (mappings: FecJournalMappingWithImport[]): FecJournalMappingWithImport[] => {
  const seenIds = new Set<string>()
  const seenJournalIdentities = new Set<string>()
  const result: FecJournalMappingWithImport[] = []

  for (const mapping of mappings) {
    const siblingIds = getSiblingIds(mapping)

    if (seenIds.has(mapping.id) || siblingIds.some((siblingId) => seenIds.has(siblingId))) {
      continue
    }

    const journalIdentityKey = getFecJournalIdentityKey(mapping)

    if (seenJournalIdentities.has(journalIdentityKey)) {
      continue
    }

    seenIds.add(mapping.id)
    for (const siblingId of siblingIds) {
      seenIds.add(siblingId)
    }
    seenJournalIdentities.add(journalIdentityKey)
    result.push(mapping)
  }

  return result
}
